import firebase from "@firebase/app"
import "@firebase/firestore"

const db = firebase.firestore()
const FieldValue = firebase.firestore.FieldValue

export  {db, FieldValue }
